import React from "react"
import { Alert, Button, Card, CardBody, CardHeader, Col, Form, Input, Label, Row, Spinner } from "reactstrap"

const ClientForm = ({
  title,
  formError,
  formData,
  isEditMode,
  saving,
  onChange,
  onSubmit,
  onClose,
}) => {
  return (
    <Card className="mb-4 app-form-card">
      <CardHeader className="bg-white d-flex align-items-center justify-content-between">
        <h5 className="mb-0">{title}</h5>
        {/* <Button color="link" className="p-0" type="button" onClick={onClose} style={{ color: '#6c63ff', fontWeight: 500 }}>
          Close
        </Button> */}
            <Button color="secondary" type="button" onClick={onClose}>
                            <i className="mdi mdi-arrow-left me-1" />Back
                          </Button>
      </CardHeader>
      <CardBody className="app-form-body">
        {formError ? <Alert color="danger">{formError}</Alert> : null}
        <Form onSubmit={onSubmit}>
          <Row className="g-3">
            <Col md={6}>
              <Label>Client Name<span style={{ color: "red" }}>*</span></Label>
              <Input
                name="clientName"
                value={formData.clientName}
                onChange={onChange}
                placeholder="Enter client name"
              />
            </Col>
            <Col md={6}>
              <Label>Company Name</Label>
              <Input
                name="companyName"
                value={formData.companyName}
                onChange={onChange}
                placeholder="Enter company name"
              />
            </Col>
            <Col md={6}>
              <Label>Email</Label>
              <Input
                name="email"
                value={formData.email}
                onChange={onChange}
                placeholder="Enter email"
              />
            </Col>
            <Col md={6}>
              <Label>Mobile Number</Label>
              <Input
                name="phone"
                value={formData.phone}
                onChange={onChange}
                placeholder="Enter phone"
                maxLength={10}
                inputMode="numeric"
                pattern="^[0-9]{10}$"
                title="Phone number must be exactly 10 digits."
                onKeyPress={e => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Col>
            <Col md={6} className="d-none">
              <Label>GST Number</Label>
              <Input
                name="gstNumber"
                value="854GJH8545"
                onChange={onChange}
                placeholder="Enter GST number"
              />
            </Col>
            {/* CITY */}
<Col md={4}>
  <Label>City</Label>
  <Input
    name="city"
    value={formData.city || ""}
    onChange={onChange}
    placeholder="Enter city"
  />
</Col>

{/* STATE */}
<Col md={4}>
  <Label>State</Label>
  <Input
    name="state"
    value={formData.state || ""}
    onChange={onChange}
    placeholder="Enter state"
  />
</Col>

{/* PINCODE */}
<Col md={4}>
  <Label>Pincode</Label>
  <Input
    name="pincode"
    value={formData.pincode || ""}
    onChange={onChange}
    placeholder="Enter pincode"
    maxLength={6}
    inputMode="numeric"
    onKeyPress={e => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    }}
  />
</Col>
            <Col md={12}>
              <Label>Address</Label>
              <Input
                type="textarea"
                name="address"
                value={formData.address}
                onChange={onChange}
                placeholder="Enter address"
                rows={3}
              />
            </Col>
          </Row>
          <div className="app-form-actions d-flex justify-content-center mt-4">
            <Button color="light" type="button" onClick={onClose} style={{ minWidth: 120, marginRight: 16 }}>
              Cancel
            </Button>
            <Button color="success" type="submit" disabled={saving} style={{ minWidth: 120 }}>
              {saving ? <Spinner size="sm" className="me-2" /> : null}
              Save
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default ClientForm
